import React from "react";
import { VerificationStep } from "src/customer/use_phone_verified_submission";
import { VerifyPhoneNumber, VerifyPhoneNumberModal } from "src/checkout/verify_phone_number_modal";

const VerificationCodeForm = ({
  verification: { formRef, ...verifyPhoneNumberProps },
  isModal = false,
}: {
  verification: VerificationStep;
  isModal?: boolean;
}) => (
  <form ref={formRef} onSubmit={(event) => event.preventDefault()}>
    {isModal ? <VerifyPhoneNumberModal {...verifyPhoneNumberProps} /> : <VerifyPhoneNumber {...verifyPhoneNumberProps} />}
  </form>
);

export default VerificationCodeForm;
